exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".speech-bubble[data-v-02d56d6b]{background:#fff}.speech-bubble[data-v-02d56d6b]:after{width:20px;content:\"\";position:absolute;top:0;left:50%;width:0;height:0;transform:rotateX(90);border:20px solid transparent;border-bottom-color:#fff;box-shadow:#191970;border-top:0;margin-left:-20px;margin-top:-20px}", ""]);

// exports
